export default "__VITE_ASSET__DGmBbiXw__"